(() => {
  const STORAGE_KEY = 'af-theme';
  const VALID_THEMES = new Set(['light', 'dark', 'auto']);
  const root = document.documentElement;

  function defaultTheme() {
    const value = root.dataset.afThemeDefault;
    return VALID_THEMES.has(value) ? value : 'auto';
  }

  function currentTheme() {
    const value = root.getAttribute('data-theme');
    return VALID_THEMES.has(value) ? value : defaultTheme();
  }

  function storedTheme() {
    try {
      const value = localStorage.getItem(STORAGE_KEY);
      return VALID_THEMES.has(value) ? value : null;
    } catch (error) {
      return null;
    }
  }

  function updateToggleState(value = currentTheme()) {
    document.querySelectorAll('[data-af-theme-value]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.afThemeValue === value));
    });
  }

  function applyTheme(value, persist = true) {
    const next = VALID_THEMES.has(value) ? value : defaultTheme();

    if (persist) {
      try {
        localStorage.setItem(STORAGE_KEY, next);
      } catch (error) {
        // Theme selection still applies for this page when storage is unavailable.
      }
    }

    root.setAttribute('data-theme', next);
    updateToggleState(next);
    document.dispatchEvent(new CustomEvent('af:theme-change', { detail: { theme: next } }));
  }

  function closeMobileMenu(menu, returnFocus = false) {
    if (!(menu instanceof HTMLDetailsElement) || !menu.open) return;
    menu.open = false;
    if (returnFocus) menu.querySelector('summary')?.focus();
  }

  document.addEventListener('click', (event) => {
    const themeButton = event.target.closest('[data-af-theme-value]');
    if (themeButton) {
      applyTheme(themeButton.dataset.afThemeValue);
      return;
    }

    document.querySelectorAll('[data-af-mobile-menu][open]').forEach((menu) => {
      if (!menu.contains(event.target)) closeMobileMenu(menu);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-af-mobile-menu][open]').forEach((menu) => {
      closeMobileMenu(menu, true);
    });
  });

  window.addEventListener('storage', (event) => {
    if (event.key !== STORAGE_KEY) return;
    const value = VALID_THEMES.has(event.newValue) ? event.newValue : defaultTheme();
    applyTheme(value, false);
  });

  document.addEventListener('shopify:section:load', () => updateToggleState());

  applyTheme(storedTheme() || currentTheme(), false);
})();
